import React from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import WizardInput from 'componentes/wizard/WizardInput.js';
import Divider from 'componentes/common/Divider.js';
import PropTypes from 'prop-types';

const ExtraData = ({ register, errors, setValue, loading }) => {
  return (
    <>
      <Row className="g-2 mb-3">
        <Col>
          <WizardInput
            label="Oportunidad"
            name="oportunidad"
            errors={errors}
            setValue={setValue}
            formGroupProps={{ className: 'mb-3' }}
            formControlProps={{
              ...register('oportunidad')
            }}
          />
        </Col>
        <Col>
          <WizardInput
            label="Fecha de Oportunidad"
            name="fechaoportunidad"
            type="date"
            errors={errors}
            setValue={setValue}
            formGroupProps={{ className: 'mb-3' }}
            formControlProps={{
              ...register('fechaoportunidad')
            }}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <WizardInput
            label="Expediente PIL"
            name="expedientepil"
            errors={errors}
            setValue={setValue}
            formGroupProps={{ className: 'mb-3' }}
            formControlProps={{
              ...register('expedientepil')
            }}
          />
        </Col>
      </Row>
      <Divider />
      <Row className="g-2 mb-3">
        <Col>
          <WizardInput
            label="Audiencia"
            name="fechaaudiencia"
            type="datetime"
            errors={errors}
            setValue={setValue}
            formGroupProps={{ className: 'mb-3' }}
            formControlProps={{
              ...register('fechaaudiencia', { required: true })
            }}
          />
        </Col>
        <Col>
          <Form.Group className="mb-4">
            <Form.Label>Es Presencial</Form.Label>
            <Form.Check {...register('espresencial')} />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col className="text-center">
          <Button
            disabled={loading}
            color="primary"
            type="submit"
            className="px-5 my-3"
          >
            {loading ? 'Guardando...' : 'Guardar'}
          </Button>
        </Col>
      </Row>
    </>
  );
};
ExtraData.propTypes = {
  register: PropTypes.func,
  errors: PropTypes.object,
  setValue: PropTypes.func,
  loading: PropTypes.bool
};
export default ExtraData;
